import './styles.css';

import Image from 'next/image';

import { StarV2Icon } from '@/shared';

import type { IHero } from '../../types';

export const HeroDarkV2 = ({
	pretitle,
	title,
	subtitle,
	image,
	reviews,
	actionTitle,
}: IHero) => {
	return (
		<div className="hero-dark-v2">
			{pretitle && <p className="hero-dark-v2-pretitle">{pretitle}</p>}
			<h1 className="hero-dark-v2-title">{title}</h1>
			{subtitle && <p className="hero-dark-v2-subtitle">{subtitle}</p>}

			<div
				className="hero-dark-v2-action-title"
				dangerouslySetInnerHTML={{ __html: actionTitle }}
			/>

			<div className="md:hidden">
				<Image
					src={image.mobile}
					alt={image.alt}
					width={1188}
					height={1067}
					className="-mb-4 ml-auto h-80 w-auto"
				/>
			</div>

			<Image
				src={image.desktop}
				alt={image.alt}
				width={1188}
				height={1067}
				className="absolute right-0 top-0 h-[85%] w-auto object-contain max-md:hidden"
			/>

			{reviews && (
				<div className="hero-dark-v2-reviews">
					<div className="hero-dark-v2-reviews-item">
						<h3 className="text-sm font-semibold text-[#252F4A] xl:text-2xl/[1.3]">
							{reviews.studentsAchievement.title}
						</h3>
						<div className="text-2xl/[1.3] font-semibold xl:text-5xl/[1.3]">
							<span>{reviews.studentsAchievement.value}</span>
						</div>
						<p className="text-xs/[1.2] text-[#4B5675] xl:text-base/[1.3]">
							{reviews.studentsAchievement.description}
						</p>
						{reviews.studentsAchievement.additionalInfo && (
							<p className="text-[10px]/[1.2] text-[#99A1B7] xl:text-xs/[1.2]">
								{reviews.studentsAchievement.additionalInfo}
							</p>
						)}
					</div>
					<div className="hero-dark-v2-reviews-item">
						<h3 className="text-sm font-semibold text-[#252F4A] xl:text-2xl/[1.3]">
							{reviews.averageRating.title}
						</h3>
						<div className="flex flex-row text-2xl/[1.3] font-semibold xl:text-5xl/[1.3]">
							<StarV2Icon className="size-6 text-[#6C3EDE] xl:mr-4 xl:size-14" />
							<span>{reviews.averageRating.value}</span>
							<span className="text-[#99A1B7]">/5</span>
						</div>
						<p className="text-xs/[1.2] text-[#4B5675] xl:text-base/[1.2]">
							по отзывам{' '}
							<span className="xl:font-semibold">
								{reviews.averageRating.description}
							</span>{' '}
							студентов
						</p>
					</div>
					{reviews.problems && (
						<div className="hero-dark-v2-reviews-item">
							<h3 className="text-sm font-semibold text-[#252F4A] xl:text-2xl/[1.3]">
								{reviews.problems.title}
							</h3>
							<div className="text-2xl/[1.3] font-semibold xl:text-5xl/[1.3]">
								<span>{reviews.problems.value}</span>
							</div>
						</div>
					)}

					{reviews.timeLearn && (
						<div className="hero-dark-v2-reviews-item">
							<h3 className="text-sm font-semibold text-[#252F4A] xl:text-2xl/[1.3]">
								{reviews.timeLearn.title}
							</h3>
							<p className="text-xs/[1.2] text-[#4B5675] xl:text-base/[1.3]">
								{reviews.timeLearn.description}
							</p>
						</div>
					)}
				</div>
			)}
		</div>
	);
};
